import { Account } from '@app/models'
import { accountsApi } from '@app/services'

import { FetchAccountsResponse } from './types'

export const fetchAccounts = async (
  accountIds: number[]
): Promise<Account[]> => {
  if (accountIds.length === 0) {
    return []
  }

  const requestBody = { accounts: accountIds }
  const { data } = await accountsApi.post<FetchAccountsResponse>(
    '/accounts/ids',
    requestBody,
    {
      headers: {
        'Accept-Language': 'all',
      },
    }
  )

  return data.accounts
}
